/**
 * @generated SignedSource<<743e73b4f204e20f10cbd826b7aa30dc>>
 * @relayHash 564fa00f88ef777d31e353f8b4e89c91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8b981ed54e2f920f3a62d139f77ef4176413c3e1093b5c55a7d69909aec3948

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsNavigationCustomisationInput = {
  entityAri: string;
  ownerAri?: string | null | undefined;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null | undefined> | null | undefined;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null | undefined> | null | undefined;
};
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type updateNavigationCustomisationMutation$variables = {
  input: SettingsNavigationCustomisationInput;
};
export type updateNavigationCustomisationMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateNavigationCustomisationMutation = {
  response: updateNavigationCustomisationMutation$data;
  variables: updateNavigationCustomisationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SettingsNavigationCustomisation",
    "kind": "LinkedField",
    "name": "settings_updateNavigationCustomisation",
    "plural": false,
    "selections": [
      {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsDisplayProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "updateNavigationCustomisationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateNavigationCustomisationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e8b981ed54e2f920f3a62d139f77ef4176413c3e1093b5c55a7d69909aec3948",
    "metadata": {},
    "name": "updateNavigationCustomisationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bd07a6abe3570c8016127c30aea341e9";

export default node;
